import {
  GetCaseDetailsResponse,
  Comment,
  Document,
  AddressResponse,
  ApplicationResponse,
  RelatedApplicationResponse,
} from 'types';
import { GetConsultationDocumentResponse } from '../consultations';
import { GetResponseDocumentResponse } from '../responses';
import { MapGeoJsonResponse } from '@tq/ui-components';
import { EMPTY_LAYER_DATA } from '../../test-util/setup/emptyLayerData';

export const MOCK_CASE_DETAILS_PLANS: Document[] = [
  {
    id: 1,
    name: '',
    datePublished: new Date('2021-04-21'),
    documentType: 'Drawing',
    drawingNumber: '29FKM48',
    description: 'Side view alterations',
  },
  {
    id: 2,
    name: '',
    datePublished: new Date('2021-03-30'),
    documentType: 'Plan',
    drawingNumber: '-',
    description: '-',
  },
  {
    id: 3,
    name: '',
    datePublished: new Date('2021-01-08'),
    documentType: 'Plan',
    drawingNumber: 'GLSJ348',
    description: 'Planning layout v2',
  },
  {
    id: 4,
    name: '',
    datePublished: new Date('2020-09-05'),
    documentType: 'Drawing',
    drawingNumber: '4K4MSK',
    description: '-',
  },
  {
    id: 5,
    name: '',
    datePublished: new Date('2019-08-04'),
    documentType: 'Drawing',
    drawingNumber: 'GLSJ348',
    description: 'Chimney extension suggestions',
  },
];

const MOCK_CASE_DETAILS_DOCUMENT: Document = {
  id: 1,
  name: '',
  datePublished: new Date('2021-04-21'),
  documentType: 'Decision',
  description: 'Side view alterations',
  sensitive: true,
};

export const MOCK_CASE_DETAILS_DOCUMENTS: Document[] = [
  MOCK_CASE_DETAILS_DOCUMENT,
  {
    id: 2,
    name: 'document 2',
    datePublished: new Date('2021-03-30'),
    documentType: 'Certificate',
    description: '-',
    sensitive: false,
  },
  {
    id: 3,
    name: 'document 3',
    datePublished: new Date('2021-01-8'),
    documentType: 'Minor Amendment',
    description: 'Planning layout v2',
    sensitive: true,
  },
  {
    id: 4,
    name: 'document 4',
    datePublished: new Date('2020-09-5'),
    documentType: 'Minor Amendment',
    description: '-',
    sensitive: false,
  },
  {
    id: 5,
    name: 'document 5',
    datePublished: new Date('2019-08-4'),
    documentType: 'Minor Amendment',
    description: 'Chimney extension suggestions',
    sensitive: true,
  },
  {
    id: 6,
    name: 'document 6',
    datePublished: new Date('2019-08-4'),
    documentType: 'Legal Agreement',
    description: 'Chimney extension suggestions',
    sensitive: true,
  },
  {
    id: 7,
    name: 'document 7',
    datePublished: new Date('2019-08-4'),
    documentType: 'Decision',
    description: 'Chimney extension suggestions',
    sensitive: true,
  },
  {
    id: 8,
    name: 'document 8',
    datePublished: new Date('2019-08-4'),
    documentType: 'Minor Amendment',
    description: 'Chimney extension suggestions',
    sensitive: true,
  },
  {
    id: 9,
    name: 'document 9',
    datePublished: new Date('2019-08-4'),
    documentType: 'Minor Amendment',
    description: 'Chimney extension suggestions',
    sensitive: true,
  },
  {
    id: 10,
    name: 'document 10',
    datePublished: new Date('2019-08-4'),
    documentType: 'Minor Amendment',
    description: '4K4MSK',
    sensitive: true,
  },
  {
    id: 11,
    name: 'document 11',
    datePublished: new Date('2019-08-4'),
    documentType: 'Drawing',
    description: 'Chimney extension suggestions',
    sensitive: true,
  },
];

export const MOCK_CASE_DETAILS_COMMENTS: Comment[] = [
  {
    commentOrder: 11,
    name: 'Benjamin Connor',
    datePublished: new Date('2019-08-4'),
    type: 'Support',
    isPetition: false,
    isGroup: false,
    documents: [],
  },
  {
    commentOrder: 12,
    name: 'The Village People',
    datePublished: new Date('2019-08-3'),
    type: 'Support',
    isPetition: true,
    isGroup: true,
    documents: [MOCK_CASE_DETAILS_DOCUMENT],
  },
  {
    commentOrder: 13,
    name: 'Benjamin Connor',
    datePublished: new Date('2019-08-2'),
    type: 'Support',
    isPetition: false,
    isGroup: true,
    documents: [MOCK_CASE_DETAILS_DOCUMENT],
  },
  {
    commentOrder: 14,
    name: 'Benjamin Connor',
    datePublished: new Date('2019-08-1'),
    type: 'Support',
    isPetition: false,
    isGroup: true,
    documents: [MOCK_CASE_DETAILS_DOCUMENT],
  },
  {
    commentOrder: 15,
    name: 'Benjamin Connor',
    datePublished: new Date('2019-07-4'),
    type: 'Support',
    isPetition: true,
    isGroup: true,
    documents: [MOCK_CASE_DETAILS_DOCUMENT],
  },
  {
    commentOrder: 16,
    name: 'Benjamin Connor',
    datePublished: new Date('2019-07-3'),
    type: 'Support',
    isPetition: false,
    isGroup: true,
    documents: [MOCK_CASE_DETAILS_DOCUMENT],
  },
  {
    commentOrder: 17,
    name: 'Benjamin Connor',
    datePublished: new Date('2019-07-2'),
    type: 'Support',
    isPetition: false,
    isGroup: true,
    documents: [MOCK_CASE_DETAILS_DOCUMENT],
  },
  {
    commentOrder: 18,
    name: 'The Village People',
    datePublished: new Date('2019-07-1'),
    type: 'Support',
    isPetition: false,
    isGroup: false,
    documents: [MOCK_CASE_DETAILS_DOCUMENT],
  },
  {
    commentOrder: 19,
    name: 'Benjamin Connor',
    datePublished: new Date('2019-06-30'),
    type: 'Neutral',
    isPetition: false,
    isGroup: false,
    documents: [MOCK_CASE_DETAILS_DOCUMENT],
  },
];

export const MOCK_CASE_DETAILS_ADDRESS: AddressResponse = {
  address:
    'Plots 1 2 12 12 12 12 12 12 1212 and 13 of previously approved residential development lands to the rear of 108 Coleraine Road Portsteward BT55 7JR',
  relatedApplicationId: 1,
  postcode: 'BT55 7JR',
  ward: 'Templepatrick',
  authority: 'Templepatrick',
};

export const MOCK_GEO_JSON: MapGeoJsonResponse = {
  geoJson: EMPTY_LAYER_DATA,
};

export const MOCK_CASE_DETAILS_APPLICATION: ApplicationResponse = {
  address: MOCK_CASE_DETAILS_ADDRESS,
  planningApplicationReferenceNo: 'LA01/2020/1353/F',
  applicationStatus: 'Valid',
  applicationType: 'Household planning permission',
  easting: 111222,
  northing: 222111,
  planningPortalReference: '1234567890',
  applicantsName: 'Bruce Banner2',
  dateReceived: new Date('2022-01-01'),
  decisionDate: new Date('2022-01-02'),
  permissionExpiryDate: new Date('2022-01-03'),
  dateValidated: new Date('2022-01-05'),
  applicationDecisionType: 'Granted',
  applicationDevelopmentType: 'Base',
  districtElectoralArea: 'Planet',
  wardName: 'Earth',
  latestNeighbourConsultationDate: new Date('2022-01-06'),
  neighbourConsultationExpiryDate: new Date('2022-01-07'),
  standardConsultationDate: new Date('2022-01-08'),
  standardConsultationExpiry: new Date('2022-01-09'),
  dateLastAdvertised: new Date('2022-01-10'),
  latestAdvertisementExpiryDate: new Date('2022-01-11'),
  committeeDate: new Date('2022-01-12'),
  applicationCalledInDate: new Date('2022-01-13'),
  departmentReferralDate: new Date('2022-01-14'),
  agentsName: 'Natasha Romanoff',
  agentsCompany: 'S.H.I.E.L.D',
  agentsPhoneNumber: '111-111-1111',
  agentsEmailAddress: 'nat@shield.org',
  caseOfficeName: 'Carol Danvers',
  caseOfficerContactNumber: 'NA',
  sensitive: true,
  proposalText:
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur ut ipsum et justo efficitur facilisis quis ut mauris. Phasellus faucibus pharetra felis. Nam aliquam non dolor vitae laoreet. Vivamus a euismod lectus. Sed faucibus vehicula odio ut scelerisque. Mauris faucibus blandit neque ut facilisis. Sed eu diam ac magna blandit interdum sed quis sapien. Vivamus blandit fermentum egestas.',
  plans: MOCK_CASE_DETAILS_PLANS,
  documents: MOCK_CASE_DETAILS_DOCUMENTS,
  comments: MOCK_CASE_DETAILS_COMMENTS,
};

export const MOCK_RELATED_APPLICATIONS: RelatedApplicationResponse[] = [
  {
    ...MOCK_CASE_DETAILS_APPLICATION,
    address: MOCK_CASE_DETAILS_ADDRESS,
    relatedApplicationReferenceNumber: 'LA01/2020/2353/G1',
    applicationReferenceNumber: 'LA01/2020/2353/G2',
    dateReceived: new Date('2022-01-03'),
    decisionDate: new Date('2022-01-04'),
    proposalText:
      '123 Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur ut ipsum et justo efficitur facilisis quis ut mauris. Phasellus faucibus pharetra felis. Nam aliquam non dolor vitae laoreet. Vivamus a euismod lectus. Sed faucibus vehicula odio ut scelerisque. Mauris faucibus blandit neque ut facilisis. Sed eu diam ac magna blandit interdum sed quis sapien. Vivamus blandit fermentum egestas.',
    singleLineOfAddress:
      'Plots 1 2 12 12 12 12 12 12 1212 and 13, 108 Coleraine Road Portsteward BT55 7JR',
    applicationTypeCategory: 'Planning',
  },
];

export const MOCK_RELATED_ADDRESSES: AddressResponse[] = [MOCK_CASE_DETAILS_ADDRESS];

export const MOCK_CASE_DETAILS: GetCaseDetailsResponse = {
  application: MOCK_CASE_DETAILS_APPLICATION,
  dataItemsToDisplay: [],
  relatedApplications: MOCK_RELATED_APPLICATIONS,
  relatedAddresses: MOCK_RELATED_ADDRESSES,
};

export const MOCK_CONSULTATION_DOCUMENT: GetConsultationDocumentResponse = {
  documentId: 1,
  documentUri: '/1.pdf',
};

export const MOCK_RESPONSE_DOCUMENT: GetResponseDocumentResponse = {
  consultationId: 1,
  responseId: 1,
  documentId: 1,
  documentUri: '/1.pdf',
};
